// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1n12z","selected":"Chip_selected__1H836"};